import { render } from "./BillConfigContent.vue?vue&type=template&id=db502ec4&scoped=true"
import script from "./BillConfigContent.vue?vue&type=script&lang=js"
export * from "./BillConfigContent.vue?vue&type=script&lang=js"

import "./BillConfigContent.vue?vue&type=style&index=0&id=db502ec4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db502ec4"]])

export default __exports__